import styled from "styled-components";

export const Divider = styled.div`
  border: 1px solid ${({ theme }) => theme.silverStart};
  height: 0px;
  width: 100%;
  margin-bottom: 16px;
`;
